/**
 * Maps a brief section id to its rendered element, so selecting a comment in the rail can
 * bring the section it belongs to into view.
 *
 * A module-level registry filled by a callback ref, mirroring `briefSectionHighlights`: the
 * element is registered exactly when it attaches and dropped when it detaches, with no effect
 * watching for it. Unlike the editor registry this covers EVERY section, prose and widget
 * alike, which is the point — a whole-section comment can target a date or checklist field
 * that never mounts a TipTap editor.
 */
export const briefSectionElements = new Map<string, HTMLElement>();

export function registerBriefSectionElement(sectionId: string) {
  return (element: HTMLElement | null) => {
    if (!element) return;
    briefSectionElements.set(sectionId, element);
    return () => {
      // Only drop our own entry: a section that remounts registers the new element before the
      // old one detaches, and an unconditional delete would remove the live registration.
      if (briefSectionElements.get(sectionId) === element) {
        briefSectionElements.delete(sectionId);
      }
    };
  };
}

export function scrollBriefSectionIntoView(
  sectionId: string,
  { reducedMotion }: { reducedMotion: boolean },
) {
  briefSectionElements.get(sectionId)?.scrollIntoView({
    behavior: reducedMotion ? 'auto' : 'smooth',
    block: 'center',
  });
}
